import { css } from 'styled-components/macro';

let detectedFlexGapSupported = false;
let isFlexGapSupported = false;

const checkFlexGapSupported = () => {
  if (detectedFlexGapSupported) {
    return isFlexGapSupported;
  }

  const flex = document.createElement('div');
  flex.style.display = 'flex';
  flex.style.flexDirection = 'column';
  flex.style.rowGap = '1px';

  flex.appendChild(document.createElement('div'));
  flex.appendChild(document.createElement('div'));

  document.body.appendChild(flex);
  const isSupported = flex.scrollHeight === 1;
  flex?.parentNode?.removeChild(flex);

  detectedFlexGapSupported = true;
  isFlexGapSupported = isSupported;

  return isSupported;
};

const flexGapPolyfill = (gap) => css`
  margin: -${gap / 2}px;

  & > * {
    margin: ${gap / 2}px !important;
  }
`;

const flexGap = (gap) => {
  if (checkFlexGapSupported()) {
    return css`
      gap: ${gap}px;
    `;
  }

  return flexGapPolyfill(gap);
};

export default flexGap;
